(function ($) {
    'use strict';

    var map; //<-- This is now available to both event listeners and the initialize() function
    var mapCenter; // Declare a variable to store the center of the map
    var centerMarker; // declare your marker

    var exhlat = '54.687914';
    var exhlng = '25.259613';

    if ($('#homepage-map').hasClass('exh')) {
        exhlat = $('#homepage-map').data('lat');
        exhlng = $('#homepage-map').data('lng');
    }

    function initialize() {
        var mapOptions = {
            // How zoomed in you want the map to start at (always required)
            zoom: 16,
            panControl: false,
            rotateControl: false,
            scaleControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            scrollwheel: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            }
        };

        mapCenter = new google.maps.LatLng(exhlat, exhlng);

        if ($('#homepage-map').length > 0) {
            map = new google.maps.Map(document.getElementById("homepage-map"), mapOptions);
            map.setCenter(mapCenter);
        }

        centerMarker = new google.maps.Marker({
            position: new google.maps.LatLng(exhlat, exhlng),
            map: map,
            title: ''
        });
    }

    function setCenter() {
        map.setCenter(mapCenter);
    }

    if ($('#homepage-map').length > 0) {
        google.maps.event.addDomListener(window, 'load', initialize);
        google.maps.event.addDomListener(window, 'setCenter', setCenter);
    }
})(jQuery);